import { render } from "./UpdateHourlyAbsenceDetails.vue?vue&type=template&id=0ba51602"
import script from "./UpdateHourlyAbsenceDetails.vue?vue&type=script&lang=js"
export * from "./UpdateHourlyAbsenceDetails.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__